var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBf2B7454E319Ef35413E3C1757Af4Dc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.7333,
    height: 2.8,
    rx: 1.4,
    fill: "#3F3F46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 5.6,
    width: 17.7333,
    height: 2.8,
    rx: 1.4,
    fill: "#3F3F46"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 11.2,
    width: 17.7333,
    height: 2.8,
    rx: 1.4,
    fill: "#3F3F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBf2B7454E319Ef35413E3C1757Af4Dc2);
export default __webpack_public_path__ + "static/media/bf2b7454e319ef35413e3c1757af4dc2.e096354a97e639481720b48be7988b38.svg";
export { ForwardRef as ReactComponent };